import schema from "../../../app/Settings/Customization/Fields/schema.json"
import { getDisplayValue } from "web/components"

const abbreviatedSummaryMethodMapping = {
  sum: "Sum",
  average: "Avg.",
  weighted_average: "Wt. Avg.",
  weighted_sum: "Wt. Sum",
}

const summaryMethodSchemaIndex = schema.findIndex(
  (f) => f.key === "summary_method"
)
const fullSummaryMethodValues = schema[summaryMethodSchemaIndex].lookup_values

export function getSummaryMethodLabel(summaryMethod, full) {
  if (!summaryMethod) return ""
  if (full) {
    return fullSummaryMethodValues.find(
      (method) => method.value === summaryMethod
    ).label
  }

  return abbreviatedSummaryMethodMapping[summaryMethod]
}

function EmptyValueMessage({ message }) {
  return <div className="italic text-gray-400">{message}</div>
}

export function displayEmptyValueMessage(tile, field) {
  const dataValue = getDisplayValue(tile.data, field.key)
  const noSummaryMethod = !field.summary_method

  if (field.is_summarizable && !dataValue && noSummaryMethod) {
    return <EmptyValueMessage message="Configuration required" />
  }

  if (!field.is_summarizable) {
    return <EmptyValueMessage message="Cannot be summarized" />
  }
}
